import crm from './crm'
import bops from './bops'
import eCommerce from './ecommerce'
import sales from './sales'
import banking from './banking'
import sbr from './sbr'
import dashboard from './dashboard'
import setup from './setup'
import property from './property'
import sites from './sites'

export default [
  ...dashboard,
  ...crm,
  ...bops,
  ...eCommerce,
  ...sales,
  ...banking,
  ...sbr,
  ...setup,
  ...property,
  ...sites,
]
